<template>
  <section id="toxicology-add-test-block" v-loading="loading">
    <div
      class="select-my-test-profiles"
      v-if="hasPermission('test_profiles', 'view')"
    >
      <h4 class="title">My Test Profiles</h4>
      <div class="form-element search-with-filter-input">
        <el-select
          v-model="selectedTestProfile"
          multiple
          placeholder="Select"
          value-key="code"
          @change="handleTestProfiles"
        >
          <el-option
            v-for="(item, index) in TestProfiles"
            :key="index"
            :label="item.title"
            :value="item._id"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <ul class="add-tests-selection">
      <li
        class="each-test"
        v-for="(category, index) of getFilteredCategories(
          'CLINICAL_CHEMISTRY',
          ['INHALENAT_ALLERGENS-36', 'FOOD_ALLERGENS-25'],
          'exclude'
        )"
        :key="index"
      >
        <el-collapse v-model="activeNameCollapse" accordion>
          <el-collapse-item :name="index" class="screening">
            <template #title>
              <el-checkbox
                class="test-category"
                :model-value="
                  isCheckAll(category.case_type_code, category.panel_id)
                "
                @change="
                  checkAll($event, category.case_type_code, category.panel_id)
                "
                :disabled="
                  category.panel_code === 'ALL_TESTS' ||
                  category.panel_code === 'SEND_OUTS'
                "
              ></el-checkbox>
              {{ category.panel_title }}
            </template>
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: baseline;
              "
            >
              <el-checkbox
                class="test-category"
                :model-value="
                  isCheckAll(category.case_type_code, category.panel_id)
                "
                @change="
                  checkAll($event, category.case_type_code, category.panel_id)
                "
                :disabled="
                  category.panel_code === 'ALL_TESTS' ||
                  category.panel_code === 'SEND_OUTS'
                "
                >All</el-checkbox
              >

              <!-- <el-button class="btn small-add-test-btn" v-if="
                category.panel_code == 'OTHER_TESTS' &&
                hasPermission('add_tests', 'view')
              " @click="handlePopup">
                ADD TESTS
              </el-button> -->
            </div>

            <el-checkbox-group v-model="selectedCategoriesWithTests">
              <div
                v-for="(item, index) of getCategoryWiseTestsData(
                  category.case_type_code,
                  category.panel_id
                )"
                :key="index"
              >
                <div class="each-check-box">
                  <el-checkbox
                    :disabled="
                      !(
                        category.panel_code === 'ALL_TESTS' ||
                        category.panel_code === 'SEND_OUTS' ||
                        category.panel_code === 'OTHER_TESTS'
                      )
                    "
                    :label="item.label_value"
                    @change="
                      checkSingleTest(
                        $event,
                        category.case_type_code,
                        category.panel_id,
                        item._id
                      )
                    "
                  >
                    {{ item.test_name }}
                  </el-checkbox>
                </div>
              </div>
            </el-checkbox-group>
          </el-collapse-item>
        </el-collapse>
      </li>
    </ul>

    <el-tabs v-model="activeToxicologyTab" class="blood-inner-tab">
      <el-tab-pane name="Allergy Test Panel">
        <template #label>
          <el-checkbox
            class="position-relative-top-3"
            :model-value="
              isMultiCheckAll('CLINICAL_CHEMISTRY', [
                'INHALENAT_ALLERGENS-36',
                'FOOD_ALLERGENS-25',
              ])
            "
            @change="
              multiCheckAll($event, 'CLINICAL_CHEMISTRY', [
                'INHALENAT_ALLERGENS-36',
                'FOOD_ALLERGENS-25',
              ])
            "
          ></el-checkbox>
          <span class="ml-10">Allergy test panel</span>
        </template>

        <ul class="add-tests-selection">
          <li
            class="each-test"
            v-for="(category, index) of getFilteredCategories(
              'CLINICAL_CHEMISTRY',
              ['INHALENAT_ALLERGENS-36', 'FOOD_ALLERGENS-25'],
              'include'
            )"
            :key="index"
          >
            <el-collapse accordion>
              <el-collapse-item :name="index">
                <template #title>
                  <el-checkbox
                    class="test-category"
                    :model-value="
                      isCheckAll(category.case_type_code, category.panel_id)
                    "
                    @change="
                      checkAll(
                        $event,
                        category.case_type_code,
                        category.panel_id
                      )
                    "
                  >
                  </el-checkbox>
                  {{ category.panel_title }}</template
                >
                <el-checkbox
                  class="test-category"
                  :model-value="
                    isCheckAll(category.case_type_code, category.panel_id)
                  "
                  @change="
                    checkAll($event, category.case_type_code, category.panel_id)
                  "
                  >All
                </el-checkbox>

                <el-checkbox-group v-model="selectedCategoriesWithTests">
                  <div
                    v-for="(item, index) of getCategoryWiseTestsData(
                      category.case_type_code,
                      category.panel_id
                    )"
                    :key="index"
                  >
                    <div class="each-check-box">
                      <el-checkbox :label="item.label_value" disabled>{{
                        item.test_name
                      }}</el-checkbox>
                    </div>
                  </div>
                </el-checkbox-group>
              </el-collapse-item>
            </el-collapse>
          </li>
        </ul>
      </el-tab-pane>
    </el-tabs>
  </section>
  <div class="default-modal heightAujust">
    <el-dialog v-model="dialogFormVisible" width="30%" height="215px">
      <div class="dialog-header">
        <span class="header-part"> Add Test Name </span>
        <el-button
          size="medium"
          class="el-white"
          type="info"
          plain
          @click="dialogFormVisible = false"
        >
          <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
        /></el-button>
      </div>
      <el-form :model="otherTestConfig" class="popup-date">
        <div class="case-creation__input">
          <el-form-item class="mb-0">
            <label for="text" class="date-label"
              >Test Name
              <span class="star">*</span>
            </label>
            <el-input
              v-model="otherTestConfig.test_name"
              placeholder="Enter Test Name"
            ></el-input>
            <p class="err" v-if="this.getErrors.test_name">
              <FormError errorName="name"></FormError>
            </p>
          </el-form-item>
          <p class="err" v-if="getErrors && getErrors.critical_error">
            <FormError errorName="critical_error"></FormError>
          </p>
        </div>
        <div class="dialog-footer pb-0">
          <el-button class="cancel-button" @click="handleClose"
            >Cancel</el-button
          >
          <el-button
            class="popup-save-button"
            @click="createTestConfig"
            v-loading="loadingProfile"
            :disabled="!isTestNameValid"
          >
            Save
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppHelper from "@/mixins/AppHelper";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";

import FormError from "@/components/misc/FormError";

export default {
  name: "BloodPanelTestSelection",
  props: ["panelTestsData", "searchString", "customProfileTest"],
  mixins: [AppHelper, UserPermissionsHelper],
  components: {
    FormError,
  },
  data() {
    return {
      activeNameCollapse: "",
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup: [],
      },
      activeToxicologyTab: "Allergy Test Panel",
      activeNameCollapseScreening: [0, 1],
      selectedTestProfile: [],
      TestProfiles: [],
      userType: "",
      dialogFormVisible: false,
      otherTestConfig: {
        test_name: "",
        status: "ACTIVE",
        is_manually_added_test: true,
        case_type: "Clinical Chemistry",
        case_type_code: "CLINICAL_CHEMISTRY",
        panel_code: "OTHER_TESTS",
        category: "Other Tests",
      },
      loadingProfile: false,
      loading: false,
      selectedCategories: [],
      // selectedCategoriesWithTests: [],
    };
  },
  mounted() {
    this.panelsTestsData = this.panelTestsData;

    this.panelsTestsData.selectedCategories.forEach((category) => {
      category.test_ids.forEach((test) => {
        this.selectedCategoriesWithTests.push(`${category.panel_id}:${test}`);
      });
    });

    this.selectedTestProfile = this.customProfileTest;
    if (this.isFacilityUser) {
      this.$store.dispatch("testProfiles/fetchCaseTypeTestProfile", {
        case_type: "CLINICAL_CHEMISTRY",
      });
    }
    this.TestProfiles =
      this.getCaseTypeTestProfiles && this.getCaseTypeTestProfiles.data
        ? this.getCaseTypeTestProfiles.data
        : [];
  },
  computed: {
    ...mapGetters("labTests", [
      "getAllLabTests",
      "getNewLabGroupWiseTests",
      "getNewLabGroupPanelTests",
      "getNewLabGroupWiseTestsData",
    ]),
    ...mapGetters("cases", ["getCaseInformation"]),
    ...mapGetters("testProfiles", ["getCaseTypeTestProfiles"]),
    ...mapGetters("auth", ["getAuthenticatedUser", "getUserPrimaryLabId"]),
    ...mapGetters("bloodOtherTests", ["getTestCreationStatus"]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    isTestNameValid() {
      return (
        this.otherTestConfig.test_name &&
        this.otherTestConfig.test_name.trim().length > 0
      );
    },
    selectedCategoriesWithTests() {
      if (!this.panelsTestsData?.selectedCategories) return [];

      return this.panelsTestsData.selectedCategories.flatMap((category) => {
        return category.test_ids.map((test) => `${category.panel_id}:${test}`);
      });
    },
  },
  methods: {
    getFilteredCategories(caseType, categories, includeType) {
      let data = [];

      if (includeType == "include") {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code &&
            el.case_type_code === caseType &&
            categories.includes(el.panel_code)
        );
      } else {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code &&
            el.case_type_code === caseType &&
            !categories.includes(el.panel_code)
        );
      }

      data = data.reduce((acc, current) => {
        const x = acc.find((item) => item.panel_id == current.panel_id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);

      return data;
    },

    getCategoryWiseTestsData(caseType, category) {
      let data = [];
      if (this.searchString) {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code === caseType &&
            el.panel_id === category &&
            (el.test_name
              .toLowerCase()
              .includes(this.searchString.toLowerCase()) ||
              el.panel_title
                .toLowerCase()
                .includes(this.searchString.toLowerCase()))
        );
      } else {
        data = this.getNewLabGroupPanelTests.filter(
          (el) => el.case_type_code === caseType && el.panel_id === category
        );
      }

      data = data.map((e) => {
        e.label_value = e.panel_id + ":" + e._id;
        return e;
      });

      return this.sortByKey(data, "test_name");
    },
    checkAll(data, caseType, panelId) {
      if (data) {
        this.panelsTestsData.selectedCategories.push({
          panel_id: panelId,
          case_type_code: caseType,
          all_tests: true,
          test_ids: this.getNewLabGroupPanelTests
            .filter((e) => e.panel_id == panelId)
            .map((e) => e._id),
        });

        this.selectedCategoriesWithTests = [
          ...this.selectedCategoriesWithTests,
          ...this.getNewLabGroupPanelTests
            .filter((e) => e.panel_id == panelId)
            .map((e) => e.label_value),
        ];
      } else {
        let index = this.panelsTestsData.selectedCategories.findIndex(
          (e) => e.panel_id == panelId && e.case_type_code == caseType
        );
        if (index > -1) {
          let panelId = this.panelsTestsData.selectedCategories[index].panel_id;
          let testIds = this.getNewLabGroupPanelTests
            .filter((e) => e.panel_id == panelId)
            .map((e) => e.label_value);
          this.selectedCategoriesWithTests =
            this.selectedCategoriesWithTests.filter(
              (e) => !testIds.includes(e)
            );
          this.panelsTestsData.selectedCategories.splice(index, 1);
        }
      }
    },
    isCheckAll(caseType, category) {
      let selectedCategory = this.panelsTestsData.selectedCategories.find(
        (selectedCategory) =>
          selectedCategory.case_type_code == caseType &&
          selectedCategory.panel_id == category
      );
      let selectedCategoryFromPanel = this.getNewLabGroupPanelTests.find(
        (e) => e.panel_id == category
      );
      if (
        selectedCategory &&
        selectedCategoryFromPanel &&
        selectedCategoryFromPanel.is_mandatory
      ) {
        return true;
      }
      return false;
    },
    checkSingleTest(data, caseType, category, testId) {
      if (data) {
        let index = this.panelsTestsData.selectedCategories.findIndex(
          (selectedCategory) =>
            selectedCategory.case_type_code == caseType &&
            selectedCategory.panel_id == category
        );

        if (index > -1) {
          if (
            this.panelsTestsData.selectedCategories[index] &&
            this.panelsTestsData.selectedCategories[index].test_ids
          ) {
            this.panelsTestsData.selectedCategories[index].test_ids.push(
              testId
            );
          } else {
            this.panelsTestsData.selectedCategories[index].test_ids = [testId];
          }
        } else {
          this.panelsTestsData.selectedCategories.push({
            panel_id: category,
            case_type_code: caseType,
            all_tests: false,
            test_ids: [testId],
          });
        }
      } else {
        let index = this.panelsTestsData.selectedCategories.findIndex(
          (selectedCategory) =>
            selectedCategory.case_type_code == caseType &&
            selectedCategory.panel_id == category
        );

        if (index > -1) {
          if (
            this.panelsTestsData.selectedCategories[index] &&
            this.panelsTestsData.selectedCategories[index].test_ids
          ) {
            let testIndex = this.panelsTestsData.selectedCategories[
              index
            ].test_ids.findIndex((e) => e == testId);
            if (testIndex > -1) {
              this.panelsTestsData.selectedCategories[index].test_ids.splice(
                testIndex,
                1
              );
            }

            if (
              this.panelsTestsData.selectedCategories[index].test_ids.length ==
              0
            ) {
              this.panelsTestsData.selectedCategories.splice(index, 1);
            }
          }
        }
      }
    },
    multiCheckAll(data, caseType, categories) {
      let categoryPanelsIds = this.getCategoriesWiseTestsData(
        caseType,
        categories,
        true
      ).map((e) => e.panel_id);

      categoryPanelsIds = Array.from(new Set(categoryPanelsIds));
      categoryPanelsIds.forEach((panelId) => {
        this.checkAll(data, caseType, panelId);
      });
    },
    getCategoriesWiseTestsData(caseType, categories, include = true) {
      let data = [];
      if (this.searchString) {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code === caseType &&
            ((include && categories.indexOf(el.panel_code) != -1) ||
              (!include && categories.indexOf(el.panel_code) == -1)) &&
            (el.test_name
              .toLowerCase()
              .includes(this.searchString.toLowerCase()) ||
              el.panel_title
                .toLowerCase()
                .includes(this.searchString.toLowerCase()))
        );
      } else {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code === caseType &&
            ((include && categories.indexOf(el.panel_code) != -1) ||
              (!include && categories.indexOf(el.panel_code) == -1))
        );
      }

      return this.sortByKey(data, "test_name");
    },
    isMultiCheckAll(caseType, categories, include = true) {
      let categoryPanelIds = this.getFilteredCategories(
        caseType,
        categories,
        "include"
      ).map((e) => e.panel_id);
      categoryPanelIds = Array.from(new Set(categoryPanelIds));
      return categoryPanelIds.every((panelId) =>
        this.panelsTestsData.selectedCategories.find(
          (category) => category.panel_id == panelId
        )
      );
    },
    handleTestProfiles() {
      this.$emit("test-profiles-selected", this.selectedTestProfile);

      const selectedIds = this.selectedTestProfile || [];

      // Get all profiles that are currently selected
      const selectedProfiles = this.TestProfiles.filter((profile) =>
        selectedIds.includes(profile._id)
      );

      // All panel_ids from currently selected profiles (flattened)
      const selectedPanelIds = selectedProfiles
        .flatMap((profile) => profile.panels?.map((p) => p.panel_id) || [])
        .filter(Boolean);

      // All known panel_ids from all profiles
      const allKnownPanelIds = this.TestProfiles.flatMap(
        (profile) => profile.panels?.map((p) => p.panel_id) || []
      ).filter(Boolean);

      // Find deselected panel_ids
      const deselectedPanelIds = allKnownPanelIds.filter(
        (panelId) => !selectedPanelIds.includes(panelId)
      );

      // ❌ Remove deselected panel_ids from selectedCategories
      this.panelsTestsData.selectedCategories =
        this.panelsTestsData.selectedCategories.filter(
          (item) => !deselectedPanelIds.includes(item.panel_id)
        );

      // ❌ Remove test labels related to deselected panel_ids
      const deselectedTestLabels = this.getNewLabGroupPanelTests
        .filter((test) => deselectedPanelIds.includes(test.panel_id))
        .map((test) => test.label_value);

      this.selectedCategoriesWithTests =
        this.selectedCategoriesWithTests.filter(
          (label) => !deselectedTestLabels.includes(label)
        );

      // ✅ Add new data for currently selected panels
      for (let profile of selectedProfiles) {
        const caseType = profile.case_type;

        for (let panel of profile.panels || []) {
          if (!panel || !panel.panel_id) continue;

          const alreadyExists = this.panelsTestsData.selectedCategories.some(
            (item) => item.panel_id === panel.panel_id
          );

          if (!alreadyExists) {
            this.panelsTestsData.selectedCategories.push({
              panel_id: panel.panel_id,
              case_type_code: caseType,
              all_tests: true,
              test_ids: panel.test_ids,
            });
          }

          // Add new labels
          const newLabels = this.getNewLabGroupPanelTests
            .filter((test) => test.panel_id === panel.panel_id)
            .map((test) => test.label_value);

          this.selectedCategoriesWithTests.push(...newLabels);
        }
      }

      // Remove duplicates in selectedCategoriesWithTests, just in case
      this.selectedCategoriesWithTests = [
        ...new Set(this.selectedCategoriesWithTests),
      ];
    },
    getUniquIds(ids) {
      return Array.from(new Set(ids));
    },
    removeAll() {
      let toxPanelTests = [].concat.apply(
        [],
        this.TestProfiles.map((e) => e.lab_test_ids)
      );
      this.panelsTestsData.selectedTestIds =
        this.panelsTestsData.selectedTestIds.filter(
          (x) => toxPanelTests.indexOf(x) == -1
        );
    },
    handlePopup() {
      this.$store.commit("errors/clear", null, { root: true });
      this.dialogFormVisible = true;
    },
    handleClose() {
      this.dialogFormVisible = false;
      this.otherTestConfig.test_name = "";
    },
    async createTestConfig() {
      this.loadingProfile = true;
      let params = { ...this.otherTestConfig };
      await this.$store.dispatch("bloodOtherTests/createBloodTest", params);

      this.loadingProfile = false;

      if (this.getTestCreationStatus) {
        this.dialogFormVisible = false;
        this.loading = true;
        await this.$store.dispatch("labTests/fetchLabGroupWiseTests", {
          get_all: true,
          lab_id: this.getUserPrimaryLabId,
          case_type_code: caseTypeValues,
        });
        await this.$store.dispatch("labTests/fetchLabPanelsWiseTests", {
          get_all: true,
          lab_id: this.getUserPrimaryLabId,
          case_type_code: caseTypeValues,
        });
        this.loading = false;
        this.otherTestConfig.test_name = "";
      } else if (!this.getErrors) {
        errorNotification(this.getError || "Error in adding Blood Test Config");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.add-tests-view {
  padding: 0;

  .inner-navbar {
    padding: 15px 25px;
    background: rgba(223, 224, 224, 0.3);
    border-bottom: 1px solid #e0e2e2;

    .title {
      .icon-block {
        display: grid;
        grid-template-columns: 40px auto;
        align-items: center;

        img {
          width: 30px;
          margin-bottom: -5px;
        }

        h3 {
          color: #0a1b4b;
          font-weight: 500;
          font-size: 1.3em;
        }
      }
    }

    .mode-close {
      background: transparent;
      border: none;
      float: right;

      img {
        width: 20px;
        height: 20px;
      }
    }

    .search-tests-block {
      display: flex;
      align-items: center;

      .search-input {
        max-width: 250px;
        min-width: 200px;
      }

      .selected-test {
        margin-left: 20px;

        ul {
          display: flex;
          flex-wrap: wrap;

          li {
            &:not(:last-child) {
              margin-right: 15px;
            }

            p {
              background: #cb2955;
              border-radius: 5px;
              color: #fff;
              font-size: 0.9em;
              padding: 2px 5px;
              line-height: 20px;
              margin: 5px 0;

              &:hover {
                cursor: pointer;
              }

              img {
                width: 20px;
                margin-bottom: -5px;
                margin-left: 3px;
              }
            }
          }
        }
      }
    }
  }

  .content {
    padding: 20px 25px;
    padding-bottom: 0 !important;

    .all-tests {
      display: flex;
      flex-wrap: wrap;

      .each-test {
        width: 33.33%;

        .each-check-box {
          .el-checkbox {
            display: flex;
            align-items: flex-start;
          }

          .el-checkbox__label {
            white-space: normal;
          }

          &:not(:last-child) {
            margin-bottom: 10px !important;
          }
        }
      }
    }

    .current-tests-section {
      padding-left: 15px;
      margin-left: -15x;
      border-left: 1px solid #efefef;
      overflow-y: scroll;
      height: calc(100vh - 170px);

      &::-webkit-scrollbar,
      &::-webkit-scrollbar-thumb {
        width: 4px;
        height: 5px;
        border-radius: 5px;
        background-clip: padding-box;
        border: 3px solid #122c74;
      }

      &::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 0 5px;
      }

      &::-webkit-scrollbar-track {
        background-color: #ffffff;
      }

      .heading {
        margin-bottom: 20px;

        h3 {
          font-size: 1.1em;
          color: #000;
        }
      }

      .current-test-list {
        padding-right: 0.75em;

        li {
          &:not(:last-child) {
            margin-bottom: 10px;
          }

          button {
            background: #f2f4f9;
            border-radius: 20px;
            border: none;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            padding: 5px 10px;
            color: #34495e;
            font-weight: 600;

            .test-close {
              img {
                width: 15px;
              }
            }
          }
        }
      }
    }
  }

  .add-test-button-group {
    padding: 0 1.5em;
    margin: 0 -25px;
    background: rgba(236, 245, 255, 0.3);
    border-top: 1px solid #d5dae2;
    text-align: right;

    .el-button {
      font-size: 1.1em;
      margin: 15px 0px;
      padding: 0.75em 1.5em;
      background: #1dbd37;
      color: #fff;
      border: none;
    }
  }
}
</style>
<style lang="scss">
.add-tests-view {
  .el-collapse-item__header {
    line-height: 1.2;
  }

  .content {
    .all-tests {
      .each-test {
        .each-check-box {
          .el-checkbox {
            display: flex;
            align-items: flex-start;
          }

          .el-checkbox__label {
            white-space: normal;
            word-wrap: break-word;
          }
        }
      }
    }
  }
}
</style>
